import { type PatchDtcCodeBody } from '@packages/clients';

import type { DtcCodeOptionalRequestParams } from './types';

/**
 * Build a PatchDtcCodeBody request payload from case number, DTC code, and optional parameters.
 *
 * @param caseNumber - the Techline case number
 * @param code - the DTC code string (e.g. "P0301")
 * @param options - optional fields such as status code, primary designation, and freeze frame status
 * @returns a PatchDtcCodeBody ready to send to the API
 */
export function buildDtcCodePatchBody(
    caseNumber: string,
    code: string,
    options?: DtcCodeOptionalRequestParams
): PatchDtcCodeBody {
    return {
        caseNumber,
        DtcCode: code,
        ...(options?.statusCode !== undefined && { Statuscode: options.statusCode }),
        ...(options?.isPrimary !== undefined && { isPrimary: options.isPrimary }),
        ...(options?.freezeFrameDataInSSM !== undefined && { freezeFrameDataInSSM: options.freezeFrameDataInSSM }),
    };
}
